import { _ as _define_property } from "@swc/helpers/_/_define_property";
import Decimal from 'decimal.js';
import { AvailableCreditModel } from './AvailableCreditModel';
import { BillableStateType } from './billable-state';
import { fromResponseDTO } from './manual-service-billing';
export class BillingControlDataModel {
    static fromDTO(dto) {
        const credits = dto.credits.map((c)=>new AvailableCreditModel(c));
        return new BillingControlDataModel(fromResponseDTO(dto.manualServices), credits, AvailableCreditModel.sumCredits(credits));
    }
    static make() {
        let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const credits = data.credits || [];
        return new BillingControlDataModel(data.manualServices || {}, credits, AvailableCreditModel.sumCredits(credits));
    }
    getManualServiceBilling(serviceId) {
        return this.manualServices[serviceId];
    }
    getManualServiceBillingStages(serviceId) {
        var _this_manualServices_serviceId;
        return ((_this_manualServices_serviceId = this.manualServices[serviceId]) === null || _this_manualServices_serviceId === void 0 ? void 0 : _this_manualServices_serviceId.billingStages) || [];
    }
    getAlreadyBilledAmount(serviceId) {
        var _this_manualServices_serviceId;
        return ((_this_manualServices_serviceId = this.manualServices[serviceId]) === null || _this_manualServices_serviceId === void 0 ? void 0 : _this_manualServices_serviceId.billedAmount) || new Decimal(0);
    }
    getIsBillable(serviceId) {
        var _this_manualServices_serviceId;
        return ((_this_manualServices_serviceId = this.manualServices[serviceId]) === null || _this_manualServices_serviceId === void 0 ? void 0 : _this_manualServices_serviceId.billableState.type) === BillableStateType.Billable;
    }
    getNonBillableReason(serviceId) {
        var _this_manualServices_serviceId, _billableState_nonBillable;
        const billableState = (_this_manualServices_serviceId = this.manualServices[serviceId]) === null || _this_manualServices_serviceId === void 0 ? void 0 : _this_manualServices_serviceId.billableState;
        if (!billableState) {
            return null;
        }
        if (billableState.type === BillableStateType.Billable) {
            return null;
        }
        return ((_billableState_nonBillable = billableState.nonBillable) === null || _billableState_nonBillable === void 0 ? void 0 : _billableState_nonBillable.reason) || null;
    }
    getManualServices() {
        return this.manualServices;
    }
    getTotalCredits() {
        return this.totalCredits;
    }
    constructor(manualServices, credits, totalCredits){
        _define_property(this, "manualServices", void 0);
        _define_property(this, "credits", void 0);
        _define_property(this, "totalCredits", void 0);
        this.manualServices = manualServices;
        this.credits = credits;
        this.totalCredits = totalCredits;
    }
}
